import {createModel} from "@rematch/core";

export const ModalTypes = {
  ALERT: 1,
  CONFIRM: 2,
  COMMON: 3
}

const modal = createModel({
  state: {
    url: '',
    title: '',
    modalType: 0,
    errors: {}
  },
  reducers: {
    setModalProps: (state: any, modalProps: any) => ({
      ...state,
      ...modalProps,
    }),
    setErrors: (state: any, errors: any) => ({
      ...state,
      errors: {...errors}
    })
  },
  effects: (dispatch: any) => ({
    async openModal({className, title, message, onConfirm, onCancel, children, buttons}: any) {
      dispatch.modal.setModalProps({
        modalType: ModalTypes.COMMON,
        className: className,
        title: title,
        message: message,
        buttons: buttons,
        onConfirm: onConfirm,
        onCancel: onCancel,
        children: children
      })
    },
    async openAlertModal({title, message}: any) {
      dispatch.modal.setModalProps({
        modalType: ModalTypes.ALERT,
        title: title,
        message: message
      })
    },
    async openConfirmModal({title, message, onConfirm, onCancel, buttons}: any) {
      dispatch.modal.setModalProps({
        modalType: ModalTypes.CONFIRM,
        title: title,
        message: message,
        buttons: buttons,
        onConfirm: onConfirm,
        onCancel: onCancel
      })
    },
    async closeModal() {
      dispatch.modal.setModalProps({
        url: '',
        title: '',
        modalType: null,
      })
    }
  })
})

export default modal;
